// extracted by mini-css-extract-plugin
export default {"container":"PreviewSkeleton__container___m6EWe"};